import React, { useState, useEffect, Fragment } from 'react';


import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from 'react-i18next';

const Menu = (props) => {
    const { t } = useTranslation();

    return (
        <>

<nav className="navbar navbar-default navbar-theme navbar-theme-3" id="main-nav" style={{ backgroundColor: "#1515151c", position: "absolute" }}>
                <div className="container _pt-10 _pb-10">
                    <div className="navbar-inner nav container " style={{paddingRight:"0px"}}>
                        <div className="navbar-header _pt-10 col-sm-4" >
                        <a href="https://www.avior.com.ve/" rel="noopener noreferrer nofollow"  >
                                <img src={`${process.env.PUBLIC_URL}/img/logo.png`}  alt="imagen" className="_w-50pct" />
                            </a>
                            <button className="navbar-toggle collapsed" data-target="#navbar-main" data-toggle="collapse" type="button" area-expanded="false">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>


                        </div>
                        <div className="collapse navbar-collapse" id="navbar-main">
                            <ul className="nav navbar-nav"></ul>
                            <ul className="nav navbar-nav navbar-right" style={{ display: 'flex', alignItems: 'center' }}>

                                <li className="navbar-nav-item-user">
                                    <a title={t('menu.inicio')} href="https://www.avior.com.ve/"  rel="noopener noreferrer nofollow" >
                                        {t('menu.inicio', 'Inicio')}
                                </a>
                                </li>
                                <li className="navbar-nav-item-user">
                                    <a title={t('menu.destinos')} href="https://www.avior.com.ve/destinos"  rel="noopener noreferrer nofollow" >
                                        {t('menu.destinos', 'Destinos')}
                                </a>
                                </li>
                                <li className="navbar-nav-item-user" style={{ marginLeft: '15px' }}>
                                    <LanguageSwitcher />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>


            {/* <nav className="navbar navbar-default navbar-primary navbar-theme navbar-theme-full  navbar-theme-border btn-shadow2"  >
                <div className="container">
                    <div className="navbar-inner nav container">
                        <div className="navbar-header">
                            <button className="navbar-toggle collapsed" data-target="#navbar-main" data-toggle="collapse" type="button" area-expanded="false">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                            <a href="https://www.avior.com.ve/" rel="noopener noreferrer nofollow"  >
                                <img src={`${process.env.PUBLIC_URL}/img/logo.png`} className="_pt-15 _pl-15  _w-40pct" />
                            </a>
                        </div>
                        <div className="collapse navbar-collapse" id="navbar-main">
                            <ul className="nav navbar-nav"></ul>
                            <ul className="nav navbar-nav navbar-right">

                                <li className="navbar-nav-item-user">
                                    <a title="Inicio" href="https://www.avior.com.ve/"  rel="noopener noreferrer nofollow" >
                                        Inicio
                                </a>
                                </li>
                                <li className="navbar-nav-item-user">
                                    <a title="Inicio" href="https://www.avior.com.ve/destinos"  rel="noopener noreferrer nofollow" >
                                        Destinos
                                </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </nav> */}
        </>
    );
}

export default Menu;